
export const TEXTURE_ONE = 0;
export const TEXTURE_TWO = 1;
export const TEXTURE_THREE = 2;
export const TEXTURE_FOUR = 3;
export const TEXTURE_FIVE = 4;
